module.exports = __webpack_public_path__ + "static/media/online-time-attendance.4920b336.png";